module.exports = __webpack_public_path__ + "img/sulfur.5cb90441.png";